import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { MONTHS_OPTIONS } from '@/lib/qualificationOptions';

interface MonthYearPickerProps {
  month: number | null;
  year: number | null;
  onMonthChange: (month: number | null) => void;
  onYearChange: (year: number | null) => void;
  label?: string;
  disabled?: boolean;
  minYear?: number;
  maxYear?: number;
}

export function MonthYearPicker({
  month,
  year,
  onMonthChange,
  onYearChange,
  label,
  disabled = false,
  minYear = 1970,
  maxYear = new Date().getFullYear(),
}: MonthYearPickerProps) {
  // Generate year options from maxYear down to minYear
  const yearOptions = [];
  for (let y = maxYear; y >= minYear; y--) {
    yearOptions.push({ value: y, label: String(y) });
  }

  return (
    <div className="space-y-1">
      {label && <Label className="text-xs">{label}</Label>}
      <div className="flex gap-2">
        <Select
          value={month?.toString() || ''}
          onValueChange={(v) => onMonthChange(v ? parseInt(v) : null)}
          disabled={disabled}
        >
          <SelectTrigger className="flex-1 h-9">
            <SelectValue placeholder="Mês" />
          </SelectTrigger>
          <SelectContent>
            {MONTHS_OPTIONS.map(opt => (
              <SelectItem key={opt.value} value={opt.value.toString()}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select
          value={year?.toString() || ''}
          onValueChange={(v) => onYearChange(v ? parseInt(v) : null)}
          disabled={disabled}
        >
          <SelectTrigger className="w-24 h-9">
            <SelectValue placeholder="Ano" />
          </SelectTrigger>
          <SelectContent>
            {yearOptions.map(opt => (
              <SelectItem key={opt.value} value={opt.value.toString()}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
